export function htmlEscape(s) {
  if (s == null) return "";
  return new Option(s).innerHTML;
}

export function setLink(element, url) {
  element.classList.toggle("disabled", !url);
  if (url) {
    element.href = url;
  } else {
    element.removeAttribute("href");
  }
}

export function setAction(element, url) {
  element.classList.toggle("disabled", !url);
  if (url) {
    element.action = url;
  } else {
    element.removeAttribute("action");
  }
}

const SAFE_ICON_CLASS = /^[a-z0-9\-_ ]+$/i;

export function safeCssClass(s, fallback = "fa-file") {
  if (!s) return fallback;
  const v = String(s).trim();
  return SAFE_ICON_CLASS.test(v) ? v : fallback;
}
